import { Alert } from '@kpa/kul';
import { CSSProperties, FC, ReactNode } from 'react';
import { useRouteError } from 'react-router-dom';

interface IErrorPage {
  title: string;
  text: string;
}

const ErrorPage: FC<IErrorPage> = ({ title, text }): ReactNode => {
  const error = useRouteError();

  console.error(error);

  return (
    <div style={styles.container as CSSProperties}>
      <Alert
        variant="info"
        title={title}
      >
        {text}
      </Alert>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: 'white',
  },
};

export default ErrorPage;
